import React, { useState, useEffect, } from 'react'
import { useDispatch } from 'react-redux';
import { setOpenLoader, setTitleLoader } from '../../../config/redux/actions';
import "../../../assets/styles/login.scss"
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AuthService from '../../../services/auth';
import { simpleAlerts } from "../../../utils/alerts";
import { clearBrowserCache } from '../../../utils/function';
import { CODES } from "../../../utils/codesHTTP";
import { Global } from '../../../config/general';

const Login = ({ setUserInfo, }) => {
    const info = Global.info;
    const infoTime = Global.infoTime;

    const dispatch = useDispatch();
    const handleOpenLoader = (value) => dispatch(setOpenLoader(value));
    const handleTitleLoader = (value) => dispatch(setTitleLoader(value));

    useEffect(() => {
        handleOpenLoader(false);
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault();
        handleOpenLoader(true);
        handleTitleLoader('Validando ...');
        try {
            const data = new FormData(event.currentTarget);
            const result = await AuthService.signIn(data);
            if (result?.status === CODES.SUCCESS_200) {
                const expirationDate = new Date(new Date().getTime() + result?.data?.expires_in * 1000);
                localStorage.setItem(infoTime, expirationDate);
                localStorage.setItem(info, JSON.stringify(result?.data));
                setUserInfo(result?.data);
                clearBrowserCache()
            } else {
                simpleAlerts({ message: result?.data?.message });
            }
            return [];
        } catch (error) {
            console.log(`Error en signIn: ${error}`);
        } finally {
            handleOpenLoader(false);
            handleTitleLoader(null);
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <form onSubmit={handleSubmit} className='login-form'>
            <div className="login-wrap">
                <h2>RunaSST</h2>
                <div className="profile-image-container">
                    <img src={`${process.env.PUBLIC_URL}/icon.png`} alt="Profile" className="profile-image" />
                </div>
                <div className="form-login">
                    <input type="text" name="usuario" placeholder="Username" required />
                    <div className="password-container">
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password" placeholder="Password" required />
                        <a
                            className="toggle-password btn-sm"
                            onClick={togglePasswordVisibility}
                            style={{ color: 'white' }}
                        >
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </a>
                    </div>
                    <button type="submit">Sign in</button>
                </div>
            </div>
        </form>
    )
}

export default Login